module.exports = __webpack_public_path__ + "static/media/artist-occasion.72a586fb.jpeg";